module.exports = __webpack_public_path__ + "static/img/icons8-magazine.3e584437.svg";